import { use } from 'react';

// auth provider
import AuthContext from 'contexts/JWTContext';
import { useMutation, useQuery } from '@tanstack/react-query';
import { login, loginMicrosoft, register } from '../services/authService';
// import AuthContext from 'contexts/FirebaseContext';
// import AuthContext from 'contexts/Auth0Context';
// import AuthContext from 'contexts/AWSCognitoContext';
// import AuthContext from 'contexts/SupabaseContext';

// ==============================|| AUTH HOOKS ||============================== //

export const useRegister = () =>
  useMutation({
    mutationFn: register
  });

export const useLogin = () =>
  useMutation({
    mutationFn: login
  });

// export const useLoginMicrosoft = () =>
// useMutation({
//   mutationFn: loginMicrosoft,
// });

export const useLoginMicrosoft = () => {
  return useQuery({
    queryKey: ['login-microsoft'],
    queryFn: loginMicrosoft
  });
};

export default function useAuth() {
  const context = use(AuthContext);

  if (!context) throw new Error('context must be use inside provider');

  return context;
}
